import { FiInfo } from '@/components/react-icons/main';
import IconV2 from '@/components/v2/IconV2.jsx';
import panelIconTabsMap from '@/schema/panelIconTabsMap.js';
import panelIconTabsPropsMap from '@/schema/panelIconTabsPropsMap.js';
import { cleanClass } from '@shared/utils/cleanClass.js';
import Tag from '@/components/Tag.jsx';

const PageSplitGroup = ({ title, description, tags = [], children, className = '', valid, info, center = false, compact = false }) => {
  const icon = valid ? panelIconTabsMap.valid : panelIconTabsMap.pending;
  const iconProps = valid ? panelIconTabsPropsMap.valid : panelIconTabsPropsMap.pending;

  return (
    <div className={cleanClass(`comp-page-split-group ${className} ${center ? 'center' : ''} ${compact ? 'compact' : ''}`)}>
      {title && (
        <div className={'left'}>
          <div className="title-row">
            <div className={'title'}>{title}</div>
            {tags?.map((n, idx) => (
              <Tag key={idx} variant={'blue'}>
                {n}
              </Tag>
            ))}
            {valid !== undefined && <IconV2 icon={icon} {...iconProps} />}
            {info && <IconV2 icon={FiInfo} size={12} className={'light-medium'} title={info} />}
          </div>
          {description && <p className={'description'}>{description}</p>}
        </div>
      )}
      <div className={'right'}>{children}</div>
    </div>
  );
};

export default PageSplitGroup;
